declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, IahOrdersController, IahOrdersRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
//import { NgbAddNewPatient } from '../../../modal/addnewpatient.modal';
import { NgbCameraUploadModal } from '../profile/patientprofileview/personaldetailview/modal/cameraupload.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { IahPipe } from '../../../pipes/actors/actorIdentity.pipes';





@Component({
  selector: 'iohorders',
  templateUrl: './iohorders.component.html',
  styleUrls: [
    './iohorders.component.scss']
  , animations: [routerTransition()]
})

export class IOHOrdersComponent implements OnInit {

  OnGoBack() {
    //alert("I cam bak");
    this.ShowList = true;
  }
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowRegister: boolean = true;
    public Showrow: boolean = true;
    public Selectedrow: boolean = false;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
    public searchText: any;
  TodayDate = new Date();
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
    SelectedFromDate: NgbDateStruct;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;
    CurrentIahOrdersController: IahOrdersController[];
    CurrentIahOrdersRequest: IahOrdersRequest;
  LoadPatients() {
      this.CurrentIahOrdersRequest = new IahOrdersRequest();
      this.CurrentIahOrdersRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
      this.pdata = this.CurrentIahOrdersController;
      this.GetIahOrdersController();
  }
  
    GetIahOrdersController() {
    this.StartRefreshing();
        this.CurrentIahOrdersRequest.ConditionalOperator = 10;
        this.CurrentIahOrdersRequest.BranchCode = AppData.Instance().SelectedBranchCode;
        this.CurrentIahOrdersRequest.FromDate = new Date();
        this.CurrentIahOrdersRequest.ToDate = new Date();

        this.actorservice.GetIahOrdersController(this.CurrentIahOrdersRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
            this.CurrentIahOrdersController = this.ApiResData.Result;
            this.pdata = this.CurrentIahOrdersController;
            ///alert(this.pdata.length);
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }



  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
      private route: ActivatedRoute,
      private loginservice: LoginService, private parserFormatter: NgbDateParserFormatter, private filter: IahPipe) { }

  ngOnInit() {

    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();

      this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.isNew = true;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.SelectedPatient.FormattedCode;
    this.LoadPatients();
    //this.GetPatientInfoByFormattedCodeController();

  }



  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  //AddNewPatient() {

  //  const modalRef = this.modalService.open(NgbAddNewPatient,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;
    
  //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  //}
  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

    SelectedPatient: IahOrdersController;
  Selectedcustomer(objCategory: any) {
      var patient: IahOrdersController = objCategory;

      if (patient != null) {
          this.SelectedPatient = null;
      this.SelectedPatient = patient;
        this.Selectedrow = true;
     
      //this.LoadPatientdetails()

    }
    else {
      this.ShowPatientDetails = false;
    }
  }


  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}
    pdata: any[];// = this.data;
    listFilter: string;
    ngOnChanges(changes: any) {
        if (JSON.stringify(changes).indexOf("data") != -1)
            this.pdata = this.CurrentIahOrdersController;
        this.criteriaChange(this.listFilter);
    }
    criteriaChange(value: any) {
        if (this.filter != null) {
            if (value != '[object Event]') {
                this.listFilter = value;
                 this.pdata = this.filter.transform(this.CurrentIahOrdersController,
                    this.listFilter);
            }
        }
    }

 
    dataChanged(newobj) {
        this._GetIahOrdersController();
    }
    _GetIahOrdersController() {
        this.StartRefreshing();
        this.CurrentIahOrdersRequest.ConditionalOperator = 10;
        this.CurrentIahOrdersRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
        this.CurrentIahOrdersRequest.ToDate = new Date();

        this.actorservice.GetIahOrdersController(this.CurrentIahOrdersRequest)
            .subscribe((result) => {
                this.ApiResData = result;
                if (!this.ApiResData.hasError) {

                    this.CurrentIahOrdersController = this.ApiResData.Result;
                    this.pdata = this.CurrentIahOrdersController;
                    this.stopRefreshing();

                }
                else {
                    this.stopRefreshing();
                    if (this.ApiResData.ErrorData != "") {

                        alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
                    }
                    else {
                        alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
                    }
                }

            },


                (error) => {

                    if (error == "401 - Unauthorized") {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();



                    }
                    else {
                        alertFunctions.AlertParamEr(error);
                        this.stopRefreshing();
                    }
                }


            );
    }


    DecrementDate() {
        //this.dateI = new Date();
        //var i = this.dateI.valueOf() + 86400000;
        //this.dateI = new Date(i);
        //this.SelectedFromDate = dateI;
        //var ind: number = 0;
        //this.diff = this.diff - 1;
        //alert(this.diff);

        var monthNo = this.SelectedFromDate.month
        var d: Date = new Date(
            this.SelectedFromDate.year,
            monthNo - 1,
            this.SelectedFromDate.day
        );
        //this.parserFormatter.parse(this.SelectedFromDate).;

        d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
        //    d.getFullYear
        //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

        //  this.SelectedFromDate = this.SelectedFromDate.
        this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
        this._GetIahOrdersController();
        //ind++;
    }
    IncrementDate() {
        //this.dateI = new Date();
        //var i = this.dateI.valueOf() + 86400000;
        //this.dateI = new Date(i);
        //this.SelectedFromDate = dateI;
        //var ind: number = 0;
        //this.diff = this.diff - 1;
        //alert(this.diff);
        var monthNo = this.SelectedFromDate.month
        var d: Date = new Date(
            this.SelectedFromDate.year,
            monthNo - 1,
            this.SelectedFromDate.day
        );
        //this.parserFormatter.parse(this.SelectedFromDate).;

        d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
        //    d.getFullYear
        //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

        //  this.SelectedFromDate = this.SelectedFromDate.
        this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
        this._GetIahOrdersController();
        //ind++;
    }
  criteriaChange2(value: string) {
   // this.RefreshPatients(value);


  }
  capture(l: PatientInfoByFormattedCodeController) {
    const modalRef = this.modalService.open(NgbCameraUploadModal,
      {
        centered: true,


      })
    modalRef.componentInstance.ActorCode = l.ActorCode;
    modalRef.componentInstance.Photo = l.Photo;
  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    //this.RefreshPatients(this.searchValue);
    }
    ViewOrder(SelectedData: IahOrdersController) {
        //var navigationExtras: NavigationExtras = {
        //    queryParams: {
        //        Code: SelectedData.Code,
        //        Name: SelectedData.CustomerName,
        //        Phone: SelectedData.MobileNumber,
        //        Address: SelectedData.DeliverToAddress,
        //        Age: SelectedData.AgeY,
        //        Date: SelectedData.OrderDate,
        //        ActorCode: SelectedData.CustomerActorCode,
        //        Status: SelectedData.OrderStatus,
        //        Total: SelectedData.TotalAmount,
        //        CreatedUser: SelectedData.CreatedUser

        //    }
        //};
        // this.router.navigate(['/healins/iohvieworder'], navigationExtras);
        this.router.navigate(['healins/iohvieworder', { Code: SelectedData.Code, OrderType: "Home" }]);

    }
  

  Payment() {

  }
  AddNewPatient() {

  }
    OpenBill() {
        const modalRef = this.modalService.open(NgbSearchPatientModal,
            {
                centered: true,
                size: 'lg',
                backdrop: 'static',
                keyboard: false
            })
        modalRef.result.then((val: string) => {

            this.router.navigate(['healins/iohreceipt', { FormattedCodedata: val, OrderType: "Home" }]);

            // modalRef.componentInstance.FormattedCode = val;
            //modalRef.componentInstance.PatientName = val;
            //modalRef.componentInstance.PatientRegistrationNumber = val;
            //modalRef.result.then(x => { this.GetTreatmentCyclesController() })
        });
    }

}
